<template>
  <!-- 巡检记录列表 -->
  <div>
    <div class="search_wrap">
      <el-form
        :model="queryParam"
        ref="form"
        label-width="80px"
        :inline="true"
        size="mini"
      >
        <el-form-item label="工作社区">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.communityName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="指导员">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.userName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="巡检员">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.inspectionUserName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <div class="selectBox">
          <span class="selectText">巡检日期</span>
          <el-date-picker
            size="mini"
            v-model="inspectionDate"
            @change="dateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>

        <div class="selectBox">
          <span class="selectText">是否在岗</span>
          <el-select
            v-model="queryParam.onDuty"
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in this.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span class="selectText">是否整洁</span>
          <el-select
            v-model="queryParam.onTidy"
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in this.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span class="selectText">是否纯净</span>
          <el-select
            v-model="queryParam.isPure"
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in this.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span class="selectText">穿着工服</span>
          <el-select
            v-model="queryParam.isWear"
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in this.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span class="selectText">是否处罚</span>
          <el-select
            v-model="queryParam.isPunishment"
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in this.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="resetForm">重置</el-button>
          <div class="exportSelectBox">
            <el-select value="更多" size="mini" @change="selectExport">
              <el-option
                value="/wlInspectionRecord/exportGssPunishment"
                label="指导员罚款导出"
              ></el-option>
              <el-option
                value="/wlInspectionRecord/exportGssPunishmentDetail"
                label="罚款明细导出"
              ></el-option>
              <el-option
                value="/wlInspectionRecord/exportIUInspectionRate"
                label="巡检员日巡检率导出"
              ></el-option>
              <el-option
                value="/wlInspectionRecord/exportIUPunishment"
                label="巡检员处罚率导出"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #isPunishment="slotData">
        <p v-if="slotData.data.row.isPunishment == 1">是</p>
        <p v-if="slotData.data.row.isPunishment == 0">否</p>
      </template>
      <template #onDuty="slotData">
        <p v-if="slotData.data.row.onDuty == 1">是</p>
        <p v-if="slotData.data.row.onDuty == 0">否</p>
      </template>
      <template #dutyPunishmentType="slotData">
        <p v-if="slotData.data.row.dutyPunishmentType == 1">警告</p>
        <p v-if="slotData.data.row.dutyPunishmentType == 2">5元</p>
        <p v-if="slotData.data.row.dutyPunishmentType == 4">20元</p>
        <p v-if="slotData.data.row.dutyPunishmentType == 6">30元</p>
        <p v-if="slotData.data.row.dutyPunishmentType == 7">40元</p>
        <p v-if="slotData.data.row.dutyPunishmentType == 5">50元</p>
      </template>
      <template #unOnDutyCause="slotData">
        <p v-if="slotData.data.row.unOnDutyCause == 1">旷工</p>
        <p v-if="slotData.data.row.unOnDutyCause == 2">请假</p>
        <p v-if="slotData.data.row.unOnDutyCause == 3">离职</p>
        <p v-if="slotData.data.row.unOnDutyCause == 4">临时调动</p>
        <p v-if="slotData.data.row.unOnDutyCause == 5">代桶</p>
        <p v-if="slotData.data.row.unOnDutyCause == 6">超出范围</p>
        <p v-if="slotData.data.row.unOnDutyCause == 7">迟到或早退</p>
      </template>
      <template #onTidy="slotData">
        <p v-if="slotData.data.row.onTidy == 1">是</p>
        <p v-if="slotData.data.row.onTidy == 0">否</p>
      </template>
      <template #tidyPunishmentType="slotData">
        <p v-if="slotData.data.row.tidyPunishmentType == 1">警告</p>
        <p v-if="slotData.data.row.tidyPunishmentType == 2">5元</p>
        <p v-if="slotData.data.row.tidyPunishmentType == 3">10元</p>
      </template>
      <template #isPure="slotData">
        <p v-if="slotData.data.row.isPure == 1">是</p>
        <p v-if="slotData.data.row.isPure == 0">否</p>
      </template>
      <template #purePunishmentType="slotData">
        <p v-if="slotData.data.row.purePunishmentType == 1">警告</p>
        <p v-if="slotData.data.row.purePunishmentType == 2">5元</p>
      </template>
      <template #isWear="slotData">
        <p v-if="slotData.data.row.isWear == 1">是</p>
        <p v-if="slotData.data.row.isWear == 0">否</p>
      </template>
      <template #wearPunishmentType="slotData">
        <p v-if="slotData.data.row.wearPunishmentType == 1">警告</p>
        <p v-if="slotData.data.row.wearPunishmentType == 2">5元</p>
      </template>
      <template #lidStatus="slotData">
        <p v-if="slotData.data.row.lidStatus == 1">打开</p>
        <p v-if="slotData.data.row.lidStatus == 0">闭合</p>
      </template>
      <template #lidPunishmentType="slotData">
        <p v-if="slotData.data.row.lidPunishmentType == 1">警告</p>
        <p v-if="slotData.data.row.lidPunishmentType == 2">5元</p>
        <p v-if="slotData.data.row.lidPunishmentType == 3">10元</p>
      </template>
      <template #handlerSlot="slotData">
        <el-button
          size="mini"
          type="primary"
          @click="getInfo(slotData.data.row, 'edit')"
          >编辑</el-button
        >
        <el-button
          size="mini"
          type="success"
          @click="getInfo(slotData.data.row, 'detail')"
          >详情</el-button
        >
      </template>
    </e-table>

    <el-drawer
      :title="title"
      :visible.sync="editDrawerShow"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        ref="form"
        :model="formList"
        label-width="80px"
        style="margin-left: 30px"
      >
        <el-form-item
          v-for="(item, index) in editFormOne"
          :key="index"
          :label="item.label"
        >
          <el-input
            type="textarea"
            :value="formList[item.model]"
            style="width: 200px"
            autosize
            readonly
            disabled
            resize="none"
          ></el-input>
        </el-form-item>

        <el-form-item label="是否在岗">
          <el-select
            v-model="formList.onDuty"
            placeholder="请选择"
            :disabled="drawerShow"
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="不在岗原因">
          <el-select
            v-model="formList.unOnDutyCause"
            placeholder="请选择"
            :disabled="drawerShow"
          >
            <el-option label value></el-option>
            <el-option label="旷工" value="1"></el-option>
            <el-option label="请假" value="2"></el-option>
            <el-option label="离职" value="3"></el-option>
            <el-option label="临时调动" value="4"></el-option>
            <el-option label="代桶" value="5"></el-option>
            <el-option label="超出范围" value="6"></el-option>
            <el-option label="迟到或早退" value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处罚类型">
          <el-select
            v-model="formList.dutyPunishmentType"
            placeholder="请选择"
            :disabled="drawerShow"
          >
            <el-option label value></el-option>
            <el-option label="警告" value="1"></el-option>
            <el-option label="5元" value="2"></el-option>
            <el-option label="20元" value="4"></el-option>
            <el-option label="30元" value="6"></el-option>
            <el-option label="40元" value="7"></el-option>
            <el-option label="50元" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否整洁">
          <el-select
            v-model="formList.onTidy"
            placeholder="请选择"
            :disabled="drawerShow"
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处罚类型">
          <el-select
            v-model="formList.tidyPunishmentType"
            placeholder="请选择"
            :disabled="drawerShow"
          >
            <el-option label value></el-option>
            <el-option label="警告" value="1"></el-option>
            <el-option label="5元" value="2"></el-option>
            <el-option label="10元" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否纯净">
          <el-select
            v-model="formList.isPure"
            placeholder="请选择"
            :disabled="drawerShow"
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处罚类型">
          <el-select
            v-model="formList.purePunishmentType"
            placeholder="请选择"
            :disabled="drawerShow"
          >
            <el-option label value></el-option>
            <el-option label="警告" value="1"></el-option>
            <el-option label="5元" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="穿着工服">
          <el-select
            v-model="formList.isWear"
            placeholder="请选择"
            :disabled="drawerShow"
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处罚类型">
          <el-select
            v-model="formList.wearPunishmentType"
            placeholder="请选择"
            :disabled="drawerShow"
          >
            <el-option label value></el-option>
            <el-option label="警告" value="1"></el-option>
            <el-option label="5元" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="桶盖状态">
          <el-select
            v-model="formList.lidStatus"
            placeholder="请选择"
            :disabled="drawerShow"
          >
            <el-option label="打开" value="1"></el-option>
            <el-option label="闭合" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处罚类型">
          <el-select
            v-model="formList.lidPunishmentType"
            placeholder="请选择"
            :disabled="drawerShow"
          >
            <el-option label value></el-option>
            <el-option label="警告" value="1"></el-option>
            <el-option label="5元" value="2"></el-option>
            <el-option label="10元" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否处罚">
          <el-input
            type="textarea"
            :value="formList.isPunishment == 1 ? '是' : '否'"
            style="width: 200px"
            autosize
            readonly
            disabled
            resize="none"
          ></el-input>
        </el-form-item>

        <el-form-item label="处罚总金额">
          <el-input
            :value="formList.punishmentAmount"
            style="width: 200px"
            readonly
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="formList.remark"
            style="width: 200px"
            :disabled="drawerShow"
          ></el-input>
        </el-form-item>
        <el-form-item label="巡检时间">
          <el-input
            v-model="formList.createTime"
            style="width: 200px"
            readonly
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="巡检照片">
          <div v-for="(item, index) in inspectionPhoto" :key="index">
            <el-image
              class="imgBox"
              :src="item"
              :preview-src-list="inspectionPhoto"
            ></el-image>
          </div>
        </el-form-item>
      </el-form>
      <div
      v-if="!drawerShow"
        style="
          width: 100%;
          padding: 12px;
          display: flex;
          justify-content: space-around;
        "
      >
        <el-button size="mini" type="primary" @click="editSubmit"
          >确定</el-button
        >
        <el-button size="mini" @click="handleClose">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
import { httpAction } from "@/api/manage";
export default {
  components: { eTable },
  mixins: [listMixin],
  data() {
    return {
      inspectionDate: "",
      dateDefaultShow: "",
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() >= Date.now();
        },
      },
      url: {
        list: "/wlInspectionRecord/list",
        getDetail: "/wlInspectionRecord/detail/{id}",
        exportXlsUrl: "/wlInspectionRecord/exportGssPunishment",
        editRecord: "/wlInspectionRecord/updateIR",
      },
      loading: false,
      queryParam: {
        // userName: "",
        // inspectionUserName: "",
        // communityName: "",
        // inspectionDateStart: "",
        // inspectionDateEnd: "",
        // onDuty: "",
        // onTidy: "",
        // isPure: "",
        // isPunishment: "",
      },
      options: [
        {
          value: "",
          label: "请选择",
        },
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      columns: [
        { field: "communityName", label: "工作社区" },
        { field: "garbageStationNo", label: "桶站号" },
        { field: "inspectionUserName", label: "巡检员" },
        { field: "userName", label: "指导员" },
        { field: "phone", label: "电话" },
        {
          field: "isPunishment",
          label: "是否处罚",
          slotName: "isPunishment",
          columnType: "slot",
        },
        {
          field: "onDuty",
          label: "是否在岗",
          slotName: "onDuty",
          columnType: "slot",
        },
        {
          field: "dutyPunishmentType",
          label: "处罚类型",
          slotName: "dutyPunishmentType",
          columnType: "slot",
        },
        {
          field: "unOnDutyCause",
          label: "不在岗原因",
          slotName: "unOnDutyCause",
          columnType: "slot",
        },
        {
          field: "onTidy",
          label: "是否整洁",
          slotName: "onTidy",
          columnType: "slot",
        },
        {
          field: "tidyPunishmentType",
          label: "处罚类型",
          slotName: "tidyPunishmentType",
          columnType: "slot",
        },
        {
          field: "isPure",
          label: "是否纯净",
          slotName: "isPure",
          columnType: "slot",
        },
        {
          field: "purePunishmentType",
          label: "处罚类型",
          slotName: "purePunishmentType",
          columnType: "slot",
        },
        {
          field: "isWear",
          label: "穿着工服/袖标",
          slotName: "isWear",
          columnType: "slot",
        },
        {
          field: "wearPunishmentType",
          label: "处罚类型",
          slotName: "wearPunishmentType",
          columnType: "slot",
        },
        {
          field: "lidStatus",
          label: "桶盖状态",
          slotName: "lidStatus",
          columnType: "slot",
        },
        {
          field: "lidPunishmentType",
          label: "处罚类型",
          slotName: "lidPunishmentType",
          columnType: "slot",
        },
        { field: "punishmentAmount", label: "处罚总金额" },
        { field: "createTime", label: "查岗时间", width: "200" },
        {
          width: 200,
          label: "操作",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
      form: [
        { label: "街道", model: "streetName" },
        { label: "工作社区", model: "communityName" },
        { label: "桶站号", model: "garbageStationNo" },
        { label: "指导员", model: "userName" },
        { label: "手机号", model: "phone" },
        { label: "巡查员", model: "inspectionUserName" },
        { label: "定位", model: "position" },
        { label: "是否在岗", model: "onDuty" },
        { label: "不在岗原因", model: "unOnDutyCauseValue" },
        { label: "处罚类型", model: "dutyPunishmentType" },
        { label: "是否整洁", model: "onTidyValue" },
        { label: "处罚类型", model: "tidyPunishmentType" },
        { label: "是否纯净", model: "isPureValue" },
        { label: "处罚类型", model: "purePunishmentType" },
        { label: "穿着工服/袖标", model: "isWearValue" },
        { label: "处罚类型", model: "wearPunishmentType" },
        { label: "桶盖状态", model: "lidStatus" },
        { label: "处罚类型", model: "lidPunishmentType" },
        { label: "是否处罚", model: "isPunishment" },
        { label: "总金额", model: "punishmentAmount" },
        { label: "备注", model: "remark" },
        { label: "巡检时间", model: "createTime" },
      ],
      title: '编辑',
      drawerShow: false,
      formList: {},
      inspectionPhoto: [],
      // srcList: [],
      editDrawerShow: false,
      editFormOne: [
        { label: "街道", model: "streetName" },
        { label: "工作社区", model: "communityName" },
        { label: "桶站号", model: "garbageStationNo" },
        { label: "指导员", model: "userName" },
        { label: "手机号", model: "phone" },
        { label: "巡查员", model: "inspectionUserName" },
        { label: "定位", model: "position" },
      ],
      // editFormTwo: [
      //   { label: "是否整洁", model: "onTidyValue" },
      //   { label: "处罚类型", model: "tidyPunishmentType" },
      //   { label: "是否纯净", model: "isPureValue" },
      //   { label: "处罚类型", model: "purePunishmentType" },
      //   { label: "是否处罚", model: "isPunishment" },
      //   { label: "总金额", model: "punishmentAmount" },
      // ],
    };
  },
  computed: {},
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  methods: {
    dateChange(date) {
      if (date) {
        this.queryParam.inspectionDateStart = date[0] + " 00:00:00";
        this.queryParam.inspectionDateEnd = date[1] + " 23:59:59";
      } else {
        this.queryParam.inspectionDateStart = "";
        this.queryParam.inspectionDateEnd = "";
      }
    },
    resetForm() {
      this.queryParam = {};
      this.inspectionDate = "";
      this.searchQuery();
    },
    getInfo(val, type) {
      if (type === "edit") {
        this.title = '编辑'
        this.editDrawerShow = true;
      } else {
        this.title = '详情'
        this.editDrawerShow = true;
        this.drawerShow = true;
      }
      httpAction("/wlInspectionRecord/detail/" + val.id, {}, "get").then(
        ({ code, data }) => {
          if (code === 200) {
            for (const key in data) {
              if (Object.hasOwnProperty.call(data, key)) {
                if (
                  typeof (data[key] - 0) === "number" &&
                  typeof data[key] !== "object"
                ) {
                  data[key] = data[key] + "";
                }
              }
            }
            this.inspectionPhoto = data.inspectionPhoto;
            this.formList = data;
          }
        }
      );
    },
    selectExport(e) {
      if (
        !this.queryParam.inspectionDateStart &&
        !this.queryParam.inspectionDateEnd
      )
        return this.$message.warning("请选择巡检日期后导出");
      let newName = "";
      if (e === "/wlInspectionRecord/exportGssPunishment")
        newName = "指导员罚款";
      if (e === "/wlInspectionRecord/exportGssPunishmentDetail")
        newName = "罚款明细";
      if (e === "/wlInspectionRecord/exportIUInspectionRate")
        newName = "巡检员日巡检率";
      if (e === "/wlInspectionRecord/exportIUPunishment")
        newName = "巡检员处罚率";
      this.handleExportXls(newName, e);
    },
    handleClose() {
      this.$confirm("确认关闭？")
        .then((_) => {
        this.editDrawerShow = false;
        this.drawerShow = false;
        this.formList = {}
        this.inspectionPhoto = []
        })
        .catch((_) => {});
    },
    editSubmit() {
      if (this.formList.onDuty === "0" && !this.formList.unOnDutyCause)
        return this.$message.warning("请选择不在岗原因");
      if (
        (this.formList.unOnDutyCause === "1" ||
          this.formList.unOnDutyCause === "6") &&
        !this.formList.dutyPunishmentType
      )
        return this.$message.warning("请选择不在岗处罚类型");

      if (this.formList.onDuty === "1" && this.formList.unOnDutyCause)
        return this.$message.warning("选择在岗后请修改不在岗原因");
      if (this.formList.onDuty === "1" && this.formList.dutyPunishmentType)
        return this.$message.warning("选择在岗后请修改不在岗处罚");

      if (this.formList.onTidy === "0" && !this.formList.tidyPunishmentType)
        return this.$message.warning("请选择不整洁处罚类型");
      if (this.formList.onTidy === "1" && this.formList.tidyPunishmentType)
        return this.$message.warning("选择整洁后,请修改整洁处罚类型");

      if (this.formList.isPure === "0" && !this.formList.purePunishmentType)
        return this.$message.warning("请选择不纯净处罚类型");
      if (this.formList.isPure === "1" && this.formList.purePunishmentType)
        return this.$message.warning("选择纯净后,请修改纯净处罚类型");

      if (this.formList.isWear === "0" && !this.formList.wearPunishmentType)
        return this.$message.warning("请选择未穿着工服/袖标处罚类型");
      if (this.formList.isWear === "1" && this.formList.wearPunishmentType)
        return this.$message.warning("选择穿着工服/袖标后,请修改穿着工服/袖标处罚类型");

      if (this.formList.lidStatus === "0" && !this.formList.lidPunishmentType)
        return this.$message.warning("请选择桶盖处罚类型");
      if (this.formList.lidStatus === "1" && this.formList.lidPunishmentType)
        return this.$message.warning("选择打开桶盖后,请修改桶盖处罚类型");


      httpAction(this.url.editRecord, this.formList, "post").then((res) => {
        if (res.code === 200) {
          this.editDrawerShow = false;
          this.$message.success = "修改成功";
          this.loadData();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.search_wrap {
  margin: 10px 0;
}
.imgBox {
  width: 150;
  height: 150px;
  border: 1px solid rgb(223, 212, 212);
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
.exportSelectBox {
  display: inline-block;
  margin-left: 10px;
  /deep/.el-input input {
    background: #409eff;
    color: white;
    width: 70px;
    height: 28px;
  }
}
</style>
